<template>
  <div class="row clearfix">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="body">
          <h2 class="card-inside-title">타입</h2>
          <div class="row clearfix">
            <div class="col-sm-12" v-if="forInputField">
              <div>
                <label class="c_radio" for="createType">
                  <input
                    type="radio"
                    name="actionType"
                    id="createType"
                    value="create"
                    @change="changeActionType(0)"
                    v-model="types"
                    checked=""
                    v-bind:disabled="$store.state.devStore.title != '__new__'"
                  />
                  <span class="checkmark"></span>
                  <span class="ml-2">생성</span>
                </label>
              </div>

              <br />
<!--              <div>-->
<!--                <label class="c_radio" for="searchType">-->
<!--                  <input-->
<!--                    type="radio"-->
<!--                    name="actionType"-->
<!--                    id="searchType"-->
<!--                    value="search"-->
<!--                    @change="changeActionType(1)"-->
<!--                    v-model="types"-->
<!--                    v-bind:disabled="$store.state.devStore.title != '__new__'"-->
<!--                  />-->
<!--                  <span class="checkmark"></span>-->
<!--                  <span class="ml-2">검색</span>-->
<!--                </label>-->
<!--              </div>-->
            </div>
          </div>

          <h2 class="card-inside-title">키 (필수)</h2>
          <div class="row clearfix">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="key"
                  placeholder="키"
                />
              </div>
            </div>
          </div>
          <h2 class="card-inside-title" v-if="forInputField">이름 (필수)</h2>
          <div class="row clearfix" v-if="forInputField">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="name"
                  placeholder="이름"
                />
              </div>
            </div>
          </div>
          <h2 class="card-inside-title" v-if="forInputField">명사 (필수)</h2>
          <div class="row clearfix" v-if="forInputField">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="noun"
                  placeholder="명사"
                />
              </div>
            </div>
          </div>
          <h2 class="card-inside-title" v-if="forInputField">설명 (필수)</h2>
          <div class="row clearfix" v-if="forInputField">
            <div class="col-sm-12">
              <textarea
                id="helpText"
                placeholder=""
                v-model="description"
                style="width: 100%; height: 80px"
              ></textarea>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="forInputField">
            보이기 옵션 (선택)
          </h2>
          <div class="row clearfix" v-if="forInputField">
            <div class="col-sm-12">
              <select class="form-control show-tick" v-model="visible">
                <option value="Y">중요(유저에게 보임)</option>
                <option value="H">숨김(유저에게 보이지 않음)</option>
<!--                <option value="N">없음</option>-->
              </select>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="forSearch">
            찾지 못할 경우 생성하기
          </h2>
          <div class="row clearfix" v-if="forSearch">
            <div class="col-sm-12">
              <label class="c_checkbox">
                <input type="checkbox" id="enableCreate" v-model="enable" />
                <span class="checkmark"></span>
                <span class="ml-2"
                  >&nbsp;'찾거나 생성하기' 함수를 만들겠습니까?</span
                >
              </label>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="enable">
            생성시키는 액션 (필수)
          </h2>
          <div class="row clearfix" v-if="enable">
            <div class="col-sm-12">
              <select class="form-control show-tick" v-model="selectAction">
                <option value="">--선택--</option>
                <option
                  v-for="(list, index) in actList"
                  :key="index"
                  :value="list.apiCode"
                >
                  {{ list.apiKey }}
                </option>
              </select>
            </div>
          </div>

          <h2 class="card-inside-title" v-if="selectAction != ''">
            찾거나 생성하기 라벨 (필수)
          </h2>
          <!-- <p>dd</p> -->
          <div class="row clearfix" v-if="selectAction != ''">
            <div class="col-sm-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="actionLabel"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>
        <div style="text-align: right; margin-bottom: 10px">
          <button
            type="button"
            class="btn btn-default"
            v-if="!forInputField"
            @click="toUpperComponent"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-primary"
            style="margin-right: 10px"
            @click="toActionInput"
            :disabled="actionBtn"
          >
            저장
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- #END# Input -->
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  props: ["typeData"],
  methods: {
    changeActionType(num) {
      console.log(num);
      if (num == 1) {
        this.forSearch = true;
      } else {
        this.forSearch = false;
      }
    },
    toUpperComponent() {
      this.$emit("cancelingFormet", "cancel-inputfield");
    },
    toActionInput() {
      // if (this.key != null) {
      //   this.key = this.key.replace(/\s/g, "");
      // }

      // if (this.name != null) {
      //   this.name = this.name.replace(/\s/g, "");
      // }

      // if (this.noun != null) {
      //   this.noun = this.noun.replace(/\s/g, "");
      // }

      if (this.key == null || this.key == "") {
        alert("키를 써주세요.");
        return;
      }

      if (this.name == null || this.name == "") {
        alert("이름을 써주세요.");
        return;
      }
      if (this.noun == null || this.noun == "") {
        alert("명사를 써주세요.");
        return;
      }

      if (this.description == null || this.description == "") {
        alert("설명을 써주세요.");
        return;
      }

      var checkEnable = 0;
      if (this.enable == true) {
        checkEnable = 1;

        if (this.actionLabel != true || this.selectAction != true) {
          alert("필수 입력 사항을 확인해주세요.");
          return;
        }
      }


      this.actionBtn = true

      var total = [checkEnable, this.selectAction, this.actionLabel];

      var param = {
        appCode: this.$store.state.devStore.appCode,
        versionCode: this.$store.state.devStore.appData.versionCode,
        apiCode: this.$store.state.devStore.apiCode,
        index: this.$store.state.devStore.reMenu,
        apiType: "action",
        apiKey: this.key,
        apiName: this.name,
        noun: this.noun,
        description: this.description,
        visible: this.visible,
        checkType: this.types,
        checkboxs: JSON.stringify(total),
        // apiText : this.description,  text에 기타 등등 넣기
      };

      if (this.$store.state.devStore.title == "__new__") {

        this.api.insertApi(param)
          .then((res) => {
            console.log("저장 : ", res);

            this.$store.state.devStore.title = res.api.apiName;
            this.$store.state.devStore.apiCode = res.api.apiCode;

            this.$store.state.devStore.formsData = [];

            this.actionBtn = false

            // this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
            // .then((res)=>{
            //   this.$store.dispatch("apiDetail", {result : res}).then(() => {

            eventbus.$emit("menuReset");

                this.$router.push({
                  name: "DevActInput",
                  params: { appId: this.$route.params.appId },
                });
              // });

            // })

          })
          .catch(() => alert("오류가 발생했습니다."));
      } else {
        // this.setSchemaData()

        this.api.updateApi(param)
          .then((res) => {
            console.log("저장 : ", res);

            this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
            .then((res)=>{
              this.$store.dispatch("apiDetail", {result : res}).then(() => {
                console.log(this.$store.state.devStore.apiData);
                console.log(this.$store.state.devStore.formsData);
                console.log(this.$store.state.devStore.configureData);

                this.actionBtn = false

                eventbus.$emit("menuReset");

                this.$router.push({
                  name: "DevActInput",
                  params: { appId: this.$route.params.appId },
                });
              });

            })
          })
          .catch(() => alert("오류가 발생했습니다. auth fields"));
      }
    },

    setSchemaData() {
      console.log("데이터 가질러 옴");
      console.log(this.$store.state.devStore.apiData);
      console.log(this.$store.state.devStore.formsData);
      console.log(this.$store.state.devStore.configureData);

      var param = {
        appCode: this.$store.state.devStore.appCode,
        apiCode: this.$store.state.devStore.apiCode,
        index: this.$store.state.devStore.reMenu,
        where: "",

        apiKey: this.key,
        apiName: this.name,
        noun: this.noun,
        description: this.description,
        visible: this.visible,
        //  enable : this.enable,
        checkType: this.types,
      };

      this.api.configSchema(param)
        .then((res) => {
          console.log("저장 : ", res);

          this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
          .then((res)=>{

              this.$store.dispatch("apiDetail", {result : res}).then(() => {
                console.log(this.$store.state.devStore.apiData);
                console.log(this.$store.state.devStore.formsData);
                console.log(this.$store.state.devStore.configureData);

                this.$router.push({
                  name: "DevActInput",
                  params: { appId: this.$route.params.appId },
                });
              });


          })
        })
        .catch(() => alert("오류가 발생했습니다. auth fields"));
    },
    dontLikeNull(value) {
      if (value.includes("null")) {
        return "";
      } else {
        return value;
      }
    },
  },

  data() {
    return {
      types: "create",
      forSearch: false,
      forInputField: true,
      checkboxing: true,

      key: null,
      name: null,
      noun: null,
      description: null,
      visible: "Y",

      actList: [],

      enable: false,
      selectAction: "",
      actionLabel: null,

      actionBtn : false,
    };
  },
  mounted() {},
  created() {
    eventbus.$on("updateAuth", () => {

      this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
      .then((res)=>{
        this.$store.dispatch("apiDetail", {result : res}).then(() => {
          this.key = this.dontLikeNull(
            this.$store.state.devStore.apiData.apiKey.replace(/"/gi, "")
          );
          this.name = this.dontLikeNull(
            this.$store.state.devStore.apiData.apiName.replace(/"/gi, "")
          );
          this.noun = this.dontLikeNull(
            this.$store.state.devStore.apiData.noun.replace(/"/gi, "")
          );
          this.description = this.dontLikeNull(
            this.$store.state.devStore.apiData.apiText.replace(/"/gi, "")
          );
          this.visible = this.dontLikeNull(
            this.$store.state.devStore.apiData.visible.replace(/"/gi, "")
          );
          this.types = this.dontLikeNull(
            this.$store.state.devStore.apiData.checkType.replace(/"/gi, "")
          );
        });

      })
    });

    console.log(this.typeData);
    if (this.typeData == "inputFields") {
      this.forInputField = !this.forInputField;
    }
    if (this.typeData == "inputlineItem") {
      this.forInputField = false;
      // this.checkboxing = !this.checkboxing
    }

    // this.actList = this.$store.state.devStore.apiAct

    if (this.$store.state.devStore.apiAct != null) {
      var list = [];
      for (var i = 0; i < this.$store.state.devStore.apiAct.length; i++) {
        if (
          this.$store.state.devStore.apiAct[i].apiCode !=
          this.$store.state.devStore.apiCode
        ) {
          list.push(this.$store.state.devStore.apiAct[i]);
        }
      }

      console.log(list);
      this.actList = list;
    }

    if (this.$store.state.devStore.title == "__new__") {
      console.log("신규");
    } else {

      this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
      .then((res)=>{
        this.$store.dispatch("apiDetail", {result : res}).then(() => {
          this.key = this.dontLikeNull(
            this.$store.state.devStore.apiData.apiKey.replace(/"/gi, "")
          );
          this.name = this.dontLikeNull(
            this.$store.state.devStore.apiData.apiName.replace(/"/gi, "")
          );
          this.noun = this.dontLikeNull(
            this.$store.state.devStore.apiData.noun.replace(/"/gi, "")
          );
          this.description = this.dontLikeNull(
            this.$store.state.devStore.apiData.apiText.replace(/"/gi, "")
          );
          this.visible = this.dontLikeNull(
            this.$store.state.devStore.apiData.visible.replace(/"/gi, "")
          );
          this.types = this.dontLikeNull(
            this.$store.state.devStore.apiData.checkType.replace(/"/gi, "")
          );

          console.log(this.types);

          if (this.types == "search") {
            this.forSearch = true;

            console.log(this.$store.state.devStore.apiData);
            if (this.$store.state.devStore.apiData.enable == 1) {
              this.enable = true;
              // console.log("action field :: ",JSON.parse(this.$store.state.devStore.apiData.actionField))

              this.selectAction = JSON.parse(
                this.$store.state.devStore.apiData.actionField
              ).code;
              this.actionLabel = JSON.parse(
                this.$store.state.devStore.apiData.actionField
              ).label;
            }
          }
        });

      })
    }
  },
};
</script>
